var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"block",class:['background-item', _vm.dark ? 'dark' : '']},[_c('div',{staticClass:"background",style:({ backgroundImage: 'url(' + _vm.image + ')', opacity: _vm.opacity })}),_vm._v(" "),_c('div',[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }